import { render } from "./AddItemModal.vue?vue&type=template&id=59fb87aa"
import script from "./AddItemModal.vue?vue&type=script&lang=js"
export * from "./AddItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__